import React from 'react';
import clsx from 'clsx';

interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, action, icon, className }) => (
  <div className={clsx('ui-empty', className)} role="status">
    {icon && <div className="ui-empty__icon" aria-hidden>{icon}</div>}
    <div className="ui-empty__title">{title}</div>
    {description && <div className="ui-empty__desc">{description}</div>}
    {action && <div className="ui-empty__action">{action}</div>}
  </div>
);
